import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
import { Animation, Reveal } from 'react-genie'
SwiperCore.use([Pagination, Scrollbar, A11y])

const resource = createResource({
  id: {
    otherkey1:
      'Kredit Pintar adalah aplikasi penyedia layanan pinjaman tanpa agunan yang bisa diakses melalui Google Play Store dan Apple Store',
    otherkey2: 'Dapatkan dana pinjaman cepat cair hanya dengan menggunakan KTP.',
    otherkey3: 'Pengajuan pinjaman dana online tersedia selama 24 jam, kapanpun dan dimanapun.',
    otherkey4:
      'Anti ribet, pelunasan pinjaman uang bisa dibayar secara bulanan melalui berbagai channel yang tersedia.',
    otherkey5: 'Aplikasi pinjaman dana online terpercaya yang telah terdaftar dan diawasi oleh OJK.',
    loanAmount: 'Jumlah Pinjaman',
    loanAmountDesc1: 'Nominal pinjaman tersedia mulai dari Rp 600.000,- hingga Rp 10.000.000,- dalam sekali transaksi.',
    loanAmountDesc2:
      'Tingkatkan riwayat kredit untuk dapatkan pinjaman uang hingga 5 Juta Rupiah, pinjaman 10 Juta Rupiah, hingga pinjaman uang 50 Juta Rupiah tanpa jaminan.',
    loanTenor: 'Lama Pinjaman',
    loanTenorDesc: 'Makin mudah lakukan pelunasan pinjaman uang cicilan per bulan.',
    loanInterest: 'Bunga',
    loanInterestDesc: 'Dapatkan KTA bunga rendah, proses cepat, dan aman dalam genggaman tangan.',
  },
  en: {
    otherkey1:
      'Kredit Pintar is a provider mortgage-free cash loan application that can be accessed through Google Play Store and Apple Store',
    otherkey2: 'Get easy cash loan only by using ID Card.',
    otherkey3: 'Online fund application available in 24 hours, anytime and anywhere.',
    otherkey4: 'Simple, loan repayment can be done monthly via various available channels.',
    otherkey5:
      'Trusted online cash loan app that is registered and supervised by the Indonesia Authorities of Financial Service (OJK).',
    loanAmount: 'Loan amount',
    loanAmountDesc1: 'Loan amount available from Rp 600.000,- until Rp 10.000.000,- in a one time-transaction.',
    loanAmountDesc2:
      'Improve the credit history and get up to 5 million Rupiahs, 10 million Rupiahs, until 50 million Rupiahs loan without mortgage.',
    loanTenor: 'Loan Tenor',
    loanTenorDesc: 'Stress-free, repayment can be done in monthly installment.',
    loanInterest: 'Loan Interests',
    loanInterestDesc: 'Get a mortgage-free cash loan, instant and safe process in your hand.',
  },
})

const OtherLoanSection = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()

  const upcontent = ['otherkey1', 'otherkey2', 'otherkey3', 'otherkey4', 'otherkey5']
  const loanList = [
    {
      imagePath: '/images/product/other-loan-section-amount.png',
      title: 'loanAmount',
      desc: ['loanAmountDesc1', 'loanAmountDesc2'],
    },
    {
      imagePath: '/images/product/other-loan-section-tenor.png',
      title: 'loanTenor',
      desc: ['loanTenorDesc'],
    },
    {
      imagePath: '/images/product/other-loan-section-interest.png',
      title: 'loanInterest',
      desc: ['loanInterestDesc'],
    },
  ]

  return (
    <OtherLoanSectionStyles>
      {width > 1000 ? (
        <div className="other-loan-section-pc">
          {upcontent.map((item: string) => (
            <div key={item} className="other-loan-section-item-text">
              {t(item as any)}
            </div>
          ))}
          <div className="other-loan-section-loan">
            {loanList.map((item, index) => (
              <Reveal key={item.imagePath} delay={200 + index * 150} animation={Animation.FadeIn}>
                <div className="other-loan-section-loan-item">
                  <img className="image" src={item.imagePath} alt="" />
                  <div className="title">{t(item.title as any)}</div>
                  <div className="desc">
                    {item.desc.map((itm) => (
                      <div key={itm}>{t(itm as any)}</div>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      ) : (
        <div className="other-loan-section-mobile">
          {upcontent.map((item: string) => (
            <div key={item} className="other-loan-section-item-text">
              {t(item as any)}
            </div>
          ))}
          <Swiper className="swiper" loop={true} pagination={{ clickable: true }}>
            {loanList.map((item) => (
              <SwiperSlide className="swiper-slide" key={item.imagePath}>
                <div className="other-loan-section-loan-item">
                  <img className="image" src={item.imagePath} alt="" />
                  <div className="title">{t(item.title as any)}</div>
                  <div className="desc">
                    {item.desc.map((itm) => (
                      <div key={itm}>{t(itm as any)}</div>
                    ))}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </OtherLoanSectionStyles>
  )
}
export default OtherLoanSection

const OtherLoanSectionStyles = styled.div`
  @media only screen and (max-width: 1000px) {
    .other-loan-section-mobile {
      margin-top: 64px;
      padding: 0 24px;
      .other-loan-section-item-text {
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #212121;
        line-height: 28px;
      }
      .swiper {
        margin: 24px 0 64px;
        .swiper-slide {
          margin-bottom: 62px;
        }
        .other-loan-section-loan-item {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 272px;
          height: 418px;
          padding: 40px 24px;
          font-family: Roboto-Regular, Roboto;
          border: 1px solid #e6eaf0;
          border-radius: 8px;
          margin: 0 auto;
          .title {
            font-size: 14px;
            font-weight: 400;
            color: #212121;
            line-height: 36px;
            margin-top: 24px;
          }
          .desc {
            font-size: 12px;
            font-weight: 400;
            color: #757575;
            line-height: 24px;
            margin-top: 16px;
          }
          .image {
            width: 56px;
            height: 56px;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .other-loan-section-pc {
      max-width: 1440px;
      margin: 0 auto;
      padding: 96px 150px 0px;
      .other-loan-section-item-text {
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        color: #212121;
        line-height: 36px;
      }
      .other-loan-section-loan {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        .other-loan-section-loan-item {
          height: 356px;
          width: 360px;
          border: 1px solid #e6eaf0;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 40px 24px;
          text-align: center;
          font-family: Roboto-Regular, Roboto;
          .title {
            margin-top: 24px;
            font-size: 24px;
            color: #212121;
            line-height: 36px;
          }
          .desc {
            line-height: 24px;
            font-size: 16px;
            color: #757575;
            margin-top: 16px;
          }
          .image {
            width: 56px;
            height: 56px;
          }
        }
      }
    }
  }
`
